import { push } from 'connected-react-router';
import { call, CallEffect, put, takeLatest } from 'redux-saga/effects';
import Notify, { AlertTypes } from 'Services/notification';
import SatService from 'Services/sat';
import { SatResponseType } from 'Services/sat/types';
import i18n from 'Services/i18n';
import { routes } from 'Constants/routes';
import { stages } from 'Constants/stages';
import { ErrorResponseType, ResponseType } from 'Types/common';
import { stopPollingAction } from '../core/actions';
import { pollOrCancelEndpoint } from '../core/saga';
import * as types from './types';

export function* fetchSatUserSaga():
  | Generator<CallEffect<ResponseType<SatResponseType>>, void, never>
  | Generator {
  try {
    const response: ResponseType<SatResponseType> = yield call(SatService.getSatUser);
    const { data } = response;
    const responseValue = data.item?.stage;
    const stage = responseValue.value;
    if (stage === stages.DATA_PARTIAL_PULLED || stage === stages.DATA_PULLED) {
      yield put(push(routes.PERSONAL_START));
      yield put(stopPollingAction());
    }
    if (stage === stages.DATA_ERROR) {
      yield put(push(routes.DATAGATHERING_ERROR));
      yield put(stopPollingAction());
    }
    if (stage === stages.EXPIRED) {
      yield put(push(routes.DATAGATHERING_IDENTIFICATION));
      yield call(Notify.sendNotification, i18n.t('dg:DG.Loader.passworderror'), AlertTypes.error);
      yield put(stopPollingAction());
    }
    if (stage === stages.VALIDATING_CREDENTIALS_ERROR) {
      yield put(push(routes.DATAGATHERING_IDENTIFICATION));
      yield call(Notify.sendNotification, i18n.t('dg:DG.Loader.rfcerror'), AlertTypes.error);
      yield put(stopPollingAction());
    }
  } catch (error) {
    const errorData = error as ErrorResponseType;
    const errorDetail = errorData?.response?.data?.detail;
    yield call(Notify.sendNotification, errorDetail, AlertTypes.error);
  }
}

export function* fetchSatUserPollingSaga(): Generator {
  yield call(pollOrCancelEndpoint, fetchSatUserSaga);
}
export function* watchDataGatheringSaga(): Generator {
  yield takeLatest(types.FETCH_SAT_USER_TYPE, fetchSatUserPollingSaga);
}
